import { useThresholdBarTooltip } from './hooks/useThresholdBarTooltip.js';
import { CircleMarker } from './markers/CircleMarker.js';
import { PillMarker } from './markers/PillMarker.js';
import { wrapper } from './styles.sty.js';
import { ThresholdBarProps } from './ThresholdBar.js';
import { THRESHOLD_BAR_THICKNESS } from './types/constants.js';
import { ChartTooltip } from '../tooltip/ChartTooltip/ChartTooltip.js';

type LayoutType =
  | 'vertical-flip'
  | 'vertical-no-flip'
  | 'horizontal-flip'
  | 'horizontal-no-flip';

export const ThresholdBarTemplate = (props: ThresholdBarProps) => {
  const {
    borderArea,
    length,
    markers,
    layout = 'vertical',
    isFlipped = false,
    onHover,
  } = props;

  const {
    showTooltip,
    tooltipPosition,
    tooltipItems,
    handleMouseMove,
    handleMouseLeave,
  } = useThresholdBarTooltip(markers, onHover);

  const flipType = isFlipped ? 'flip' : 'no-flip';
  const layoutType: LayoutType = `${layout}-${flipType}`;

  return (
    <div
      className={wrapper({
        borderArea,
        layoutType,
      })}
      style={{ height: length }}
    >
      <svg width={THRESHOLD_BAR_THICKNESS} height={length}>
        {markers.map((marker, index) => {
          const { y0, y1, color } = marker;

          if (y0 === y1) {
            return (
              <CircleMarker
                x={8}
                y={y0}
                color={color}
                key={`threshold-bar-circle-marker-${marker.id}`}
                onMouseMove={(event) => handleMouseMove(event, index)}
                onMouseLeave={handleMouseLeave}
              />
            );
          }

          return (
            <PillMarker
              x={4}
              y0={y0}
              y1={y1}
              color={color}
              key={`threshold-bar-pill-marker-${marker.id}`}
              onMouseMove={(event) => handleMouseMove(event, index)}
              onMouseLeave={handleMouseLeave}
            />
          );
        })}
      </svg>
      {showTooltip && tooltipPosition && (
        <ChartTooltip
          position={tooltipPosition}
          onMouseLeave={handleMouseLeave}
        >
          <ChartTooltip.Body>
            {tooltipItems.map(({ id, name, color, values }) => {
              return (
                <ChartTooltip.SeriesItem
                  key={id}
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  color={color!.Default}
                  name={name.toString()}
                  value={values}
                />
              );
            })}
          </ChartTooltip.Body>
        </ChartTooltip>
      )}
    </div>
  );
};

ThresholdBarTemplate['displayName'] = 'ThresholdBarTemplate';
